import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import axios from 'axios'
import VueAxios from 'vue-axios'
import VueAuth from '@websanova/vue-auth'
import './registerServiceWorker'
import config from './config'
import LogRocket from 'logrocket'
import bugsnag from '@bugsnag/js'
import bugsnagVue from '@bugsnag/plugin-vue'

import VueAnalytics from 'vue-analytics'

Vue.use(VueAnalytics, {
  id: 'UA-100101606-20',
  router
})

require('./bootstrap')

Vue.use(VueAxios, axios)

Vue.axios.defaults.baseURL = config.API_URL
Vue.router = router

if (process.env.NODE_ENV === 'production') {
  LogRocket.init(config.LOGROCKET_ID)
  const bugsnagClient = bugsnag({
    apiKey: '937cc6bffbb7ee3505c8c39d262eb139',
    appVersion: process.env.VUE_APP_SENTRY_RELEASE || 'test'
  })
  bugsnagClient.use(bugsnagVue, Vue)
  Vue.prototype.$bugsnagClient = bugsnagClient
}

Vue.use(VueAuth, {
  auth: require('@websanova/vue-auth/drivers/auth/bearer.js'),
  http: require('@websanova/vue-auth/drivers/http/axios.1.x.js'),
  router: require('@websanova/vue-auth/drivers/router/vue-router.2.x.js'),
  notFoundRedirect: '/dashboard'
})

Vue.config.productionTip = false

let errorOut = (data) => {
  console.log('ERROR', data)
  if (typeof data === 'string') {
    Vue.prototype.$snotify.error(data)
  } else if (data.response) {
    Vue.prototype.$snotify.error(data.response.data.message)
  }

}
Vue.prototype.$errorOut = errorOut
Vue.prototype.$config = config

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
